import styled from 'styled-components';
import tw from 'twin.macro';
import { Body } from '../../../../styled components/Typography';
import { changedTint } from '../../ListViewBookings/ListViewBookings.style';

/* The value of one detail row of a card. A changed value is tinted on its own
 * rather than with the whole card: on a card the details are the columns, so
 * the mark can say which of them changed. */
export const CardDetailValue = styled(Body)<{ $changed: boolean }>(({ $changed }) => [
  tw`m-0`,
  $changed && changedTint
]);
